import { Component, OnInit } from '@angular/core';
import { ResultsEventComponent } from '../../results-event/results-event.component';

@Component({
  selector: 'app-results-event-mobile',
  templateUrl: './results-event-mobile.component.html',
  styleUrls: ['./results-event-mobile.component.less']
})
export class ResultsEventMobileComponent extends ResultsEventComponent {

}
